import React from 'react'

import { 
    About,
    Footer,
    Header,
    Skills,
    Testimonial,
    Work,
    Blog

} from './container'

import { Navbar} from './components';
import './App.scss'

import AnimatedCursor from "react-animated-cursor"


const App = () => {
  return (
   <div className='app'>
        <AnimatedCursor
          color='128, 0, 128'
          trailingSpeed={5}
        />
        <Navbar />
        <Header />
        <About />
        <Work />
        <Skills />
        <Blog />
        <Testimonial />
        <Footer />
   </div>
  )
}

export default App
